import {ApolloLink, Observable} from '@apollo/client';
import type {
  InternalOperation,
  unstable_InternalOperation as RevampInternalOperation,
} from '@sail/data';

export default function createAbortNetworkFetchLink() {
  return new ApolloLink(function abortNetworkFetchLink(
    // This union is not ideal. It would be cleaner if this link operated on one
    // generic type that both pipelines would extend from. But given that we
    // only use .getContext() in this link, it's not worth the effort to clean
    // up the types in this library.
    operation: InternalOperation | RevampInternalOperation,
    forward,
  ) {
    let controller: AbortController | null = new AbortController();

    operation.setContext(({fetchOptions = {}}) => ({
      fetchOptions: {
        ...fetchOptions,
        signal: controller?.signal,
      },
    }));

    return new Observable(function abortNetworkFetchObserver(observer) {
      const subscription = forward(operation).subscribe({
        next: function abortLinkNext(result) {
          return observer.next(result);
        },
        error: function abortLinkError(error) {
          controller = null;
          return observer.error(error);
        },
        complete: function abortCompleteError() {
          controller = null;
          return observer.complete();
        },
      });

      return function abortNetworkFetchLinkUnsubscribe() {
        if (controller) {
          controller.abort();
        }

        subscription.unsubscribe();
      };
    });
  });
}
